<template>
  <div>

      <!-- Form container -->
      <div class="d-flex align-items-center bg-white p-5 mt-6">
        <!-- Inner container -->
        <!-- Have to add `.d-flex` to control width via `.col-*` classes -->
        <div class="d-flex col-sm-7 col-md-5 col-lg-4 px-0 px-xl-4 mx-auto">
          <div class="w-100">

            <!-- Logo -->
            <div class="d-flex justify-content-center align-items-center mb-4">
            
              
              
            </div>
           <!-- / Logo -->

          <h4 class="text-center text-muted font-weight-normal mt-3 mb-2">Endre passord</h4>


            <b-alert class="font-weight-normal" v-model="showPasswordAlert" variant="danger" dismissible>
             Incorrect username or password.
            </b-alert>

            <b-alert class="font-weight-normal" v-model="showSuccessAlert" variant="success" dismissible>
             Passordet ditt har blitt endret, <b-link href="#/login">klikk her</b-link> for å logge inn.
            </b-alert>

            <b-alert class="font-weight-normal" v-model="showErrorAlert" variant="danger" dismissible>
             Noe gikk galt. Vennligst kontakt support@aquaservices.no for hjelp.
            </b-alert>

            <!-- Form -->
            <div v-if="passwordForm == true">
              <form class="mt-4">
                <b-form-group label="Skriv inn nytt passord">
                  <b-input type="password" placeholder="Nytt passord" v-on:keyup.enter="resetPassword" v-model="password" />
                </b-form-group>

                <div class="d-flex justify-content-between align-items-center mt-2">
                  <b-btn variant="primary mt-3" block v-on:click="resetPassword()">Endre passord</b-btn>
                </div>
              </form>
            </div>


          <div class="mt-3 mb-3 text-center">
              <b-link  href="/">Tilbake til forsiden</b-link>
          </div>

          <!-- / Form -->
            <div class="text-center mt-5">
                <img class="bottom-img-login mb-3" :src="`${publicUrl}img/logo/eines-logo.svg`" alt>
                <br>
               <small class="mt-5 mb-3 text-muted ">&copy; 2021 - Aquaservices.no</small>
            </div>
          </div>
        </div>
      </div>
      <!-- / Form container -->

  </div>
</template>

  <script>
  import axios from 'axios'
 
  

  export default {
      data() {
        return {
          password: "",
          passwordForm: true,
          showSuccessdAlert: false,
          showPasswordAlert: false,
          showErrorAlert: false,
        };
      },
      components: {
        
      },
      props: ["code"],
      methods: {
        resetPassword() {

          // Request API.
          axios.post('https://api.eines-as.no/auth/reset-password', {
              code: this.$route.query.code,
              password: this.password,
              passwordConfirmation: this.password,
            })
            .then(response => {
              this.showSuccessAlert = true
              this.passwordForm = false
              
            })
            .catch(error => {
              this.showErrorAlert = true
            });

        }
        
      }
    };

  </script>

  <style src="@/vendor/styles/pages/authentication.scss" lang="scss"></style>

  <style lang="css">
  
 .bottom-img-login {
    width: 200px !important;
  }
  
  </style>
 


   


  
